import { useParams } from 'react-router-dom'
import EditHepExerciseForm from './EditHepExerciseForm'
import { useGetHepExercisesQuery } from './hepexercisesApiSlice'
import { useGetExercisesQuery } from "../exercises/exercisesApiSlice"


import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'


const EditHepExercise = () => {

    useTitle('DPE: Edit HEP Exercise')

    const { id } = useParams()

    const { hepexercise } = useGetHepExercisesQuery("hepexercisesList", {
        selectFromResult: ({ data }) => ({
            hepexercise: data?.entities[id]
        }),
    })

    const { exercises } = useGetExercisesQuery("exercisesList", {
        selectFromResult: ({ data }) => ({
            exercises: data?.ids.map(id => data?.entities[id])
        }),
    })


    if (!hepexercise || !exercises) return <PulseLoader color={"#5f788a"} />

    const content = <EditHepExerciseForm hepexercise={hepexercise} exercises={exercises}/>

    return content


}

export default EditHepExercise